var map = {
	"./ar/AdministrativePlan": "859b",
	"./ar/AdministrativePlan.js": "859b",
	"./ar/AdministrativeReport": "cf29",
	"./ar/AdministrativeReport.js": "cf29",
	"./ar/AdministrativeVisit": "ae92",
	"./ar/AdministrativeVisit.js": "ae92",
	"./ar/Class": "58e2",
	"./ar/Class.js": "58e2",
	"./ar/Client": "0fb0",
	"./ar/Client.js": "0fb0",
	"./ar/Customers": "6956",
	"./ar/Customers.js": "6956",
	"./ar/DayOffRequests": "ce77",
	"./ar/DayOffRequests.js": "ce77",
	"./ar/DebtRecordVisit": "b0dd",
	"./ar/DebtRecordVisit.js": "b0dd",
	"./ar/DoubleVisitsReports": "e1cb",
	"./ar/DoubleVisitsReports.js": "e1cb",
	"./ar/EmployeeStock": "73fb",
	"./ar/EmployeeStock.js": "73fb",
	"./ar/Exams": "0e42",
	"./ar/Exams.js": "0e42",
	"./ar/ExternalEntities": "d1c5",
	"./ar/ExternalEntities.js": "d1c5",
	"./ar/Home": "573b",
	"./ar/Home.js": "573b",
	"./ar/JournalDeliveryOfSamples": "622a",
	"./ar/JournalDeliveryOfSamples.js": "622a",
	"./ar/JournalItems": "432b",
	"./ar/JournalItems.js": "432b",
	"./ar/Login": "71c6",
	"./ar/Login.js": "71c6",
	"./ar/MedicalRepPlan": "d359",
	"./ar/MedicalRepPlan.js": "d359",
	"./ar/MedicalRepRates": "d622",
	"./ar/MedicalRepRates.js": "d622",
	"./ar/ModificationRequests": "35f6",
	"./ar/ModificationRequests.js": "35f6",
	"./ar/NavigationDrawer": "b939",
	"./ar/NavigationDrawer.js": "b939",
	"./ar/PharmaceuticalForms": "0dc9",
	"./ar/PharmaceuticalForms.js": "0dc9",
	"./ar/PricesTypes": "8503",
	"./ar/PricesTypes.js": "8503",
	"./ar/Products": "8590",
	"./ar/Products.js": "8590",
	"./ar/ProductsStatement": "89ca",
	"./ar/ProductsStatement.js": "89ca",
	"./ar/RegionManagement": "93f0",
	"./ar/RegionManagement.js": "93f0",
	"./ar/Role": "e781",
	"./ar/Role.js": "e781",
	"./ar/Salaries": "796f",
	"./ar/Salaries.js": "796f",
	"./ar/SamplesStatement": "0c79",
	"./ar/SamplesStatement.js": "0c79",
	"./ar/SamplesTabs": "249a",
	"./ar/SamplesTabs.js": "249a",
	"./ar/Settings": "4a75",
	"./ar/Settings.js": "4a75",
	"./ar/SpecialtyAndTeams": "a058",
	"./ar/SpecialtyAndTeams.js": "a058",
	"./ar/Staff": "e951",
	"./ar/Staff.js": "e951",
	"./ar/StatisticsChart": "a4a6",
	"./ar/StatisticsChart.js": "a4a6",
	"./ar/Teams": "9e08",
	"./ar/Teams.js": "9e08",
	"./ar/Vacations": "e164",
	"./ar/Vacations.js": "e164",
	"./ar/VisitedDoctor": "0e36",
	"./ar/VisitedDoctor.js": "0e36",
	"./ar/Visits": "5ca4",
	"./ar/Visits.js": "5ca4",
	"./ar/VisitsGroupByMedicalRep": "67b5",
	"./ar/VisitsGroupByMedicalRep.js": "67b5",
	"./ar/VisitsTab": "9acc",
	"./ar/VisitsTab.js": "9acc",
	"./ar/WarehousesStatistics": "113d",
	"./ar/WarehousesStatistics.js": "113d",
	"./ar/WeeklyReport": "f80f",
	"./ar/WeeklyReport.js": "f80f",
	"./ar/companies": "8dec",
	"./ar/companies.js": "8dec",
	"./ar/customersTypes": "6cef",
	"./ar/customersTypes.js": "6cef",
	"./ar/medicalRepSamples": "f168",
	"./ar/medicalRepSamples.js": "f168",
	"./ar/specializations": "ec10",
	"./ar/specializations.js": "ec10",
	"./en/AdministrativePlan": "40c6",
	"./en/AdministrativePlan.js": "40c6",
	"./en/AdministrativeReport": "a9e5",
	"./en/AdministrativeReport.js": "a9e5",
	"./en/AdministrativeVisit": "f7b3",
	"./en/AdministrativeVisit.js": "f7b3",
	"./en/Class": "534d",
	"./en/Class.js": "534d",
	"./en/Client": "0123",
	"./en/Client.js": "0123",
	"./en/Customers": "a696",
	"./en/Customers.js": "a696",
	"./en/DayOffRequests": "aef5",
	"./en/DayOffRequests.js": "aef5",
	"./en/DebtRecordVisit": "c49f",
	"./en/DebtRecordVisit.js": "c49f",
	"./en/DoubleVisitsReports": "a298",
	"./en/DoubleVisitsReports.js": "a298",
	"./en/EmployeeStock": "00fd",
	"./en/EmployeeStock.js": "00fd",
	"./en/Exams": "6e2c",
	"./en/Exams.js": "6e2c",
	"./en/ExternalEntities": "05da",
	"./en/ExternalEntities.js": "05da",
	"./en/Home": "564b",
	"./en/Home.js": "564b",
	"./en/JournalDeliveryOfSamples": "ff35",
	"./en/JournalDeliveryOfSamples.js": "ff35",
	"./en/JournalItems": "e535",
	"./en/JournalItems.js": "e535",
	"./en/Login": "b64f",
	"./en/Login.js": "b64f",
	"./en/MedicalRepPlan": "9307",
	"./en/MedicalRepPlan.js": "9307",
	"./en/MedicalRepRates": "84cc",
	"./en/MedicalRepRates.js": "84cc",
	"./en/ModificationRequests": "27fd",
	"./en/ModificationRequests.js": "27fd",
	"./en/NavigationDrawer": "b01b",
	"./en/NavigationDrawer.js": "b01b",
	"./en/PharmaceuticalForms": "c7bf",
	"./en/PharmaceuticalForms.js": "c7bf",
	"./en/PricesTypes": "0b7a",
	"./en/PricesTypes.js": "0b7a",
	"./en/Products": "5833",
	"./en/Products.js": "5833",
	"./en/ProductsStatement": "7e97",
	"./en/ProductsStatement.js": "7e97",
	"./en/RegionManagement": "18e8",
	"./en/RegionManagement.js": "18e8",
	"./en/Role": "722b",
	"./en/Role.js": "722b",
	"./en/Salaries": "6643",
	"./en/Salaries.js": "6643",
	"./en/SamplesStatement": "2e74",
	"./en/SamplesStatement.js": "2e74",
	"./en/SamplesTabs": "0953",
	"./en/SamplesTabs.js": "0953",
	"./en/Settings": "0101",
	"./en/Settings.js": "0101",
	"./en/SpecialtyAndTeams": "15d8",
	"./en/SpecialtyAndTeams.js": "15d8",
	"./en/Staff": "3298",
	"./en/Staff.js": "3298",
	"./en/StatisticsChart": "492f",
	"./en/StatisticsChart.js": "492f",
	"./en/Teams": "42a5",
	"./en/Teams.js": "42a5",
	"./en/Vacations": "9f37",
	"./en/Vacations.js": "9f37",
	"./en/VisitedDoctor": "69566",
	"./en/VisitedDoctor.js": "69566",
	"./en/Visits": "be6d",
	"./en/Visits.js": "be6d",
	"./en/VisitsGroupByMedicalRep": "1f88",
	"./en/VisitsGroupByMedicalRep.js": "1f88",
	"./en/VisitsTab": "b39d",
	"./en/VisitsTab.js": "b39d",
	"./en/WarehousesStatistics": "2975",
	"./en/WarehousesStatistics.js": "2975",
	"./en/WeeklyReport": "a9fd",
	"./en/WeeklyReport.js": "a9fd",
	"./en/companies": "1b70",
	"./en/companies.js": "1b70",
	"./en/customersTypes": "5b2e",
	"./en/customersTypes.js": "5b2e",
	"./en/medicalRepSamples": "397e",
	"./en/medicalRepSamples.js": "397e",
	"./en/specializations": "afcc",
	"./en/specializations.js": "afcc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b07b";